import { render, staticRenderFns } from "./Traumaliste.vue?vue&type=template&id=03e78fd1&scoped=true&lang=pug&"
import script from "./Traumaliste.vue?vue&type=script&lang=ts&"
export * from "./Traumaliste.vue?vue&type=script&lang=ts&"
import style0 from "./Traumaliste.vue?vue&type=style&index=0&id=03e78fd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e78fd1",
  null
  
)

export default component.exports